/**
 * @generated SignedSource<<e4d714792b8316262634de7a7fdee91a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type VirtualAgentIntentTemplateType = "DISCOVERED" | "SHARED" | "STANDARD" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$data = {
  readonly description: string | null | undefined;
  readonly name: string;
  readonly noOfQuestions: number | null | undefined;
  readonly type: VirtualAgentIntentTemplateType;
  readonly " $fragmentType": "templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar";
};
export type templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$key = {
  readonly " $data"?: templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "templateDialog_servicedeskSettingsVirtualAgentCreateIntentTemplatesSidebar",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "type"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "noOfQuestions"
    }
  ],
  "type": "VirtualAgentIntentTemplate"
};

(node as any).hash = "e3dbc52c4dc7e3bfd6c7e6a0e51a5090";

export default node;
